import testFnc from "./components/test";
testFnc();

import lazyImg from "./components/lazyImg";
lazyImg();


import loader from "./components/loader";
loader();

import switchTheme from "./components/switchTheme";
switchTheme();

import swipers from "./components/swipers";
swipers();

import tabs from "./components/tabs";
tabs();

import header from "./components/header";
header();

import mobileMenu from "./components/mobileMenu";
mobileMenu();

import cookies from "./components/cookies";
cookies();

import select from "./components/select";
select();

import modals from "./components/modals";
modals();

import map from "./components/map";
map();

import mask from "./components/mask";
mask();

import match from "./components/match";
match();

import teamsFilter from "./components/teamsFilter";
teamsFilter();

import account from "./components/account";
account();

import registration from "./components/registration";
registration();

import pageSearch from "./components/pageSearch";
pageSearch();

import tableSort from "./components/tableSort";
tableSort();

import tables from "./components/tables";
tables();

import mainSort from "./components/mainSort";
mainSort();





/* let toObserve = 'js-to-observe';
let allObserve = document.querySelectorAll(`.${toObserve}`);


const observer = new MutationObserver((mutations) => {
    let needUpdate = false;

    mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
            // if (node.nodeType === 1) {
            //     if (node.matches(`
            //         .switcher__btn,
            //         .switcher__btn *
            // `)) {
            //         needUpdate = true;
            //     }
            // }
            if (node.nodeType === 1) {
                if (node.matches(`.${toObserve} *`)) {
                    needUpdate = true;
                }
            }
        });
    });

    if (needUpdate) {
        testFnc();
        switchTheme();
    }
});

observer.observe(document.body, {
    childList: true, // отслеживаем добавление/удаление дочерних элементов
    subtree: true    // отслеживаем изменения во всем поддереве
}); */

/* document.querySelector('.switcher').innerHTML += `<button class="switcher__btn js-test">test</button>`;
document.querySelector('.switcher').innerHTML += `<button class="switcher__btn js-test">test</button>`; */

/* document.querySelector('.switcher2').innerHTML += `<button class="switcher__btn js-test2">test</button>`;
document.querySelector('.switcher2').innerHTML += `<button class="switcher__btn js-test2">test</button>`; */

let toObserve = "js-to-observe";
let allObserve = document.querySelectorAll(`.${toObserve}`);

const observer = new MutationObserver((mutations) => {
  let needUpdate = false;

  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === 1) {
        if (node.matches(`.${toObserve} *`)) {
          needUpdate = true;
        }
      }
    });
  });

  if (needUpdate) {
    console.log("observe");
    modals();
  }
});

observer.observe(document.body, {
  childList: true, // отслеживаем добавление/удаление дочерних элементов
  subtree: true, // отслеживаем изменения во всем поддереве
});
